import { OpenInNew, Download, Edit } from "@mui/icons-material";
import { Box, Button, ImageListItem, Stack, Typography } from "@mui/material";

import PDFLoader from "./PDFLoader";

const PDFPreview = ({
  title,
  fileUrl,
  loading,
  onEdit,
  onView,
  onDownload,
  showEdit = false,
}) => {
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        p: 2,
        boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
        position: "relative",
        pb: "inherit",
      }}
    >
      <ImageListItem
        key="1"
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          gap={2}
          sx={{ mb: 2 }}
        >
          <Typography
            sx={{
              fontWeight: 300,
              color: "#090909",
              fontSize: "16px",
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {title}
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            {showEdit && (
              <Edit
                onClick={onEdit}
                sx={{
                  my: "auto",
                  cursor: "pointer",
                }}
                fontSize="medium"
                color="#090909"
              />
            )}

            <OpenInNew
              onClick={onView}
              sx={{
                my: "auto",
                cursor: "pointer",
              }}
              fontSize="medium"
              color="#090909"
            />
          </Box>
        </Stack>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            background: "#E9EEF1",
          }}
        >
          <iframe
            src={fileUrl}
            title="file-preview"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "224px",
            }}
          />
          <PDFLoader loading={loading} />
        </Box>

        <Box sx={{ my: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            gap={2}
            sx={{ mb: 2 }}
          >
            <Download sx={{ my: "auto" }} fontSize="medium" color="#090909" />

            <Typography
              sx={{
                fontWeight: 300,
                color: "#090909",
                fontSize: "14px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              PDF
            </Typography>
          </Stack>

          <Button
            className="form-button"
            sx={{ width: "100%" }}
            size="large"
            variant="contained"
            onClick={onDownload}
          >
            Download
          </Button>
        </Box>
      </ImageListItem>
    </Box>
  );
};

export default PDFPreview;
